import { render, staticRenderFns } from "./App.vue?vue&type=template&id=54a71499&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=54a71499&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a71499",
  null
  
)

export default component.exports